import React from 'react';
import { IOverviewBox, EOverviewValueSize } from './IOverviewBox';
import ToolTip from '@appComponents/ToolTip/ToolTip';
import QuestionMark from '@appComponents/QuestionMark/QuestionMark';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';

import * as style from './OverviewBoxStyle.module.scss'
const OverviewBox: React.FunctionComponent<IOverviewBox> = ({ label, amount, tooltip }) => {

  const renderTooltip = (tooltip: string): JSX.Element => (
    <ToolTip text={tooltip}>
      <QuestionMark />
    </ToolTip>
  );

  const amountFontSize = (size: EOverviewValueSize) => {
    if (size === EOverviewValueSize.large) return style.boxAmountLarge;
    return style.boxAmountSmall;
  };

  return (
    <div className={style.box}>
      <div className={style.boxOneLiner}>
        <p className={style.boxLabel}>{label}</p>
        {tooltip && renderTooltip(tooltip)}
      </div>
      <p className={`${style.boxAmount} ${amountFontSize(amount.size)}`}>
        <CurrencyElement value={amount.value} currency="usd"/>
      </p>
    </div>
  );
};

export default OverviewBox;
